
    <footer>
      <div class="text-center">
        © {{ currentYear }}  - Powered by <img src="../../../assets/images/InfoVision_logo.png" alt="Logo" class="login-logo">
      </div>
    </footer>